import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { PurchaseOrderSelect } from './Select/PurchaseOrderSelect'

export const purchaseOrderContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.purchaseOrder.purchaseOrderSelect).to(PurchaseOrderSelect)
})
